import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "field label large" }
const _hoisted_2 = { class: "field label large" }
const _hoisted_3 = { class: "field label large" }
const _hoisted_4 = { class: "field label large" }
const _hoisted_5 = { class: "field label large textarea" }
const _hoisted_6 = { class: "field label large suffix border" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Sitz auswählen *", -1)
const _hoisted_8 = ["value"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", null, "arrow_drop_down", -1)
const _hoisted_10 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tickets_input = _resolveComponent("tickets-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_tickets_input, {
        label: "Vorname *",
        cy: "firstname",
        modelValue: $setup.reg.firstname,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.reg.firstname) = $event)),
        val: $setup.v$.firstname
      }, null, 8, ["modelValue", "val"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_tickets_input, {
        label: "Nachname *",
        cy: "lastname",
        modelValue: $setup.reg.lastname,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.reg.lastname) = $event)),
        val: $setup.v$.lastname
      }, null, 8, ["modelValue", "val"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_tickets_input, {
        label: "Mobile *",
        cy: "phone",
        modelValue: $setup.reg.phone,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.reg.phone) = $event)),
        val: $setup.v$.phone,
        onBlurred: $setup.format
      }, null, 8, ["modelValue", "val"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_tickets_input, {
        label: "E-Mail",
        cy: "email",
        modelValue: $setup.reg.email,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.reg.email) = $event)),
        val: $setup.v$.email
      }, null, 8, ["modelValue", "val"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_tickets_input, {
        label: "Bemerkungen",
        type: "textarea",
        cy: "notes",
        modelValue: $setup.reg.notes,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.reg.notes) = $event)),
        val: $setup.v$.notes
      }, null, 8, ["modelValue", "val"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.seatId) = $event)),
        "data-cy": "seat"
      }, [
        _hoisted_7,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.seats, (seat) => {
          return (_openBlock(), _createElementBlock("option", {
            key: `${seat.stadium}-${seat.id}`,
            value: seat.id
          }, _toDisplayString(seat.block) + " – Reihe " + _toDisplayString(seat.row) + ", Platz " + _toDisplayString(seat.seat) + " (" + _toDisplayString(seat.owner) + ")", 9, _hoisted_8))
        }), 128))
      ], 512), [
        [_vModelSelect, $setup.seatId]
      ]),
      _hoisted_9
    ]),
    _createElementVNode("nav", null, [
      _createElementVNode("button", {
        class: "round primary",
        disabled: $setup.v$.$errors.length > 0 || !$setup.seatId,
        "data-cy": "save",
        onClick: $setup.save
      }, "Reservieren", 8, _hoisted_10),
      _createElementVNode("button", {
        class: "round secondary",
        onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.emit('cancel')))
      }, "Abbrechen")
    ])
  ], 64))
}